// src/components/common/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const categories = [
    'Agriculture',
    'Business',
    'Education',
    'Entertainment',
    'Art',
    'Investment',
    'Uncategorized',
    'Weather'
  ];

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 pt-12 mt-16">
      <div className="container mx-auto px-4">
        {/* Categories */}
        <div className="mb-10">
          <h3 className="text-white text-lg font-semibold mb-6">Categories</h3>
          <div className="flex flex-wrap justify-center md:justify-start gap-3">
            {categories.map(category => (
              <Link
                key={category}
                to={`posts/categories/${category}`}
                className="px-4 py-2 bg-gray-700 text-white rounded-full text-sm hover:bg-primary transition-colors"
              >
                {category}
              </Link>
            ))}
          </div>
        </div>

        {/* Newsletter */}
        <div className="mb-10">
          <h3 className="text-white text-lg font-semibold mb-4 text-center">Stay Updated</h3>
          <form className="flex flex-col sm:flex-row gap-2 max-w-md mx-auto">
            <input 
              type="email" 
              placeholder="Your email address" 
              className="flex-grow px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
            />
            <button 
              type="submit" 
              className="px-4 py-2 bg-primary text-white rounded-md hover:bg-opacity-90 transition-colors"
            >
              Subscribe
            </button>
          </form>
        </div>

        {/* Site Links */}
        <div className="border-t border-gray-700 pt-8 pb-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-white text-sm mb-4 md:mb-0">
            &copy; {currentYear} Blog Website. All Rights Reserved.
          </div>
          
          <div className="flex gap-6">
            <Link to="/about" className="text-gray-400 hover:text-white transition-colors text-sm">
              About
            </Link>
            <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors text-sm">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-400 hover:text-white transition-colors text-sm">
              Terms of Use
            </Link>
            <Link to="/contact" className="text-gray-400 hover:text-white transition-colors text-sm">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;